module.exports = __webpack_public_path__ + "static/media/shell32_24.5a264a05.ico";